import { AsyncAction } from 'src/utils/reduxUtils'
import { ApiService, callClientSecureApi } from './api/callApi'
import { call, put, takeLatest } from 'redux-saga/effects'
import { Endpoints } from 'src/constants/endpoints'
import { FetchDriver, UploadDebitCard } from 'src/constants/actionTypes'
import { PaymentMethodTypeEnum } from 'src/interfaces/paymentMethod'

interface DebitCardRequest {
  cardNumber: string
  cardExpiration: string
  zipcode: string
  stepId: string
}

function* onUploadDebitCard(action: AsyncAction<DebitCardRequest>) {
  const { cardNumber, cardExpiration, stepId, zipcode } = action.payload

  try {
    yield call(callClientSecureApi, Endpoints.UploadPaymentMethod, {
      method: 'POST',
      body: {
        stepId,
        paymentMethodType: PaymentMethodTypeEnum.Card,
        cardDetails: {
          cardNumber,
          cardExpiration,
          zipcode,
        },
      },
      apiService: ApiService.Paraworks,
    })

    yield put(UploadDebitCard.success())

    yield put(FetchDriver.request())

    if (action.next) {
      action.next(null)
    }
  } catch (err: any) {
    const errorMessage = err?.payload?.message || 'Failed to upload debit card'

    yield put(UploadDebitCard.failed(err))

    if (action.next) {
      action.next(errorMessage)
    }
  }
}

export function* debitCardSaga() {
  yield takeLatest(UploadDebitCard.type.REQUEST, onUploadDebitCard)
}
